import { InventoryValues } from '@/components/forms/form-inventory/FormInventory';
import useGetEquipmentTypes from '@/hooks/queries/equipments-api/useGetEquipmentTypes';
import usePatchEquipment from '@/hooks/queries/equipments-api/usePatchEquipment';
import useGetEquipmentById from '@/hooks/queries/equipments-api/usGetEquipmentById';
import { getChangedValues } from '@/utils/forms';
import { useParams } from 'react-router-dom';

const useEditInventory = () => {
  const { id } = useParams();
  const {
    data: equipmentItem,
    isError: isErrorGetEquipment,
    isLoading: isLoadingGetEquipment
  } = useGetEquipmentById(id);
  const {
    data: inventoryCategories,
    isLoading: isLoadingEquipmentTypes,
    isError: isErrorEquipmentTypes
  } = useGetEquipmentTypes();
  const { mutate, isPending } = usePatchEquipment();

  const isError = isErrorEquipmentTypes || isErrorGetEquipment;
  const isLoading = isLoadingEquipmentTypes || isLoadingGetEquipment;

  const defaultValues = {
    name: equipmentItem?.name ?? '',
    code: equipmentItem?.code ?? '',
    description: equipmentItem?.description ?? '',
    equipmentType: equipmentItem?.equipmentType?.id ?? ''
  };

  const onSubmit = (data: InventoryValues) => {
    const onlyChangedData = getChangedValues<Partial<InventoryValues>>(
      defaultValues,
      data
    );
    mutate({
      payload: onlyChangedData,
      equipmentId: equipmentItem ? equipmentItem.id : ''
    });
  };

  return {
    isError,
    isLoading,
    isPending,
    equipmentItem,
    inventoryCategories,
    onSubmit,
    defaultValues
  };
};

export default useEditInventory;
